import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=1b296b79&scoped=true"
import script from "./app-footer.ts?vue&type=script&lang=ts&external"
export * from "./app-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./app-footer.less?vue&type=style&index=0&id=1b296b79&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b296b79",
  null
  
)

export default component.exports